import { Input } from 'antd'
import { useSelector } from 'react-redux'

import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'

const Search = Input.Search

const SearchFieldFactory = ({ updateFilter, placeholder }) => {
  const t = useSelector(selectTranslate)

  return (
    <div>
      <Search
        placeholder={placeholder || t('Filter data')}
        onKeyUp={e => updateFilter(e.target.value)}
        onPaste={e => updateFilter(e.clipboardData.getData('Text'))}
        style={{ width: 200 }}
      />
    </div>
  )
}

export default SearchFieldFactory
